import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className={`flex items-center justify-between px-8 py-4 rounded-full transition-all duration-500 ${
          scrolled 
            ? 'bg-white/80 backdrop-blur-xl shadow-lg border border-white/20' 
            : 'bg-white/10 backdrop-blur-md border border-white/20'
        }`}>
          <Link to="/">
            <h1 className={`text-2xl font-light tracking-wider cursor-pointer transition-colors duration-300 ${
              scrolled ? 'text-[#4A4A4A] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'
            }`} style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              LUMIÈRE
            </h1>
          </Link>
          <div className="flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-base font-light transition-colors duration-300 whitespace-nowrap ${
                isActive('/') 
                  ? 'text-[#C9A961]' 
                  : scrolled 
                    ? 'text-[#6B6B6B] hover:text-[#C9A961]' 
                    : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/collections" 
              className={`text-base font-light transition-colors duration-300 whitespace-nowrap ${
                isActive('/collections') 
                  ? 'text-[#C9A961]' 
                  : scrolled 
                    ? 'text-[#6B6B6B] hover:text-[#C9A961]' 
                    : 'text-white/90 hover:text-white'
              }`}
            >
              Collections
            </Link>
            <Link 
              to="/about" 
              className={`text-base font-light transition-colors duration-300 whitespace-nowrap ${
                isActive('/about') 
                  ? 'text-[#C9A961]' 
                  : scrolled 
                    ? 'text-[#6B6B6B] hover:text-[#C9A961]' 
                    : 'text-white/90 hover:text-white'
              }`}
            >
              Our Story
            </Link>
            <Link 
              to="/contact" 
              className={`text-base font-light transition-colors duration-300 whitespace-nowrap ${
                isActive('/contact') 
                  ? 'text-[#C9A961]' 
                  : scrolled 
                    ? 'text-[#6B6B6B] hover:text-[#C9A961]' 
                    : 'text-white/90 hover:text-white'
              }`}
            >
              Book Appointment
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
